<main class="shell">
  <router-outlet />
</main>
